import { useContext } from "react";

import { FormContext, type FormContextValue } from "../contexts/FormContext.ts";
import { NoFormContextError } from "../utils/errors.ts";

/**
 * Hook providing access to the current context within a form.
 *
 * @returns The current context within a form.
 * @throws {NoFormContextError} When no form is in context.
 */
export function useFormContext<T = unknown>(): FormContextValue<T> {
  const formContext = useContext(FormContext);
  if (!formContext) {
    throw new NoFormContextError();
  }
  return formContext;
}
